module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_album-fc4f4884a9819c0f7aa276d68213f0a4.jpg";